"use strict";

exports.__esModule = true;
exports.default = identity;

// inspired by rambda and ramda
function identity(value) {
  return value;
}